































import { Component, Emit, Inject, Mixins, Prop } from 'vue-property-decorator';
import ManagementGeofences from './ManagementGeofences.vue';
import { MarkStateStore } from './marks.state';
import { Geofence, Point } from '../../../core/models';
import { TrackingService } from '../../../core/api';
import { OptionalCompanyID, EventBus, TypeEventBus } from '../../../core/utils';
import { NotificationStoreHelper, RootStoreHelper } from '../../../core/mixins';
import { getBoundsFromPosition } from '../../../core/components/Map';
import { getGeofenceError } from '../../../tracking/utils';

@Component<GeofenceTabItem>({
    components: { ManagementGeofences },
    subscriptions() {
        return {
            elements$: this.geoFencesStore.filterElements$,
            selected$: this.geoFencesStore.selected$,
            loading$: this.geoFencesStore.selectLoading(),
            filter$: this.geoFencesStore.filter$
        };
    }
})
export default class GeofenceTabItem extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    elements$: Geofence[];
    selected$: Geofence[];
    filter$: string;
    loading$: boolean;
    errorState: boolean = false;
    loadingDelete: boolean = false;
    @Prop() companySelected: OptionalCompanyID;
    @Prop() tab: string;
    @Inject() geoFencesStore: MarkStateStore<Geofence>;

    handleSelectElements(selectedElements: Geofence[]): void {
        this.geoFencesStore.setSelected(selectedElements);
    }

    handleAddSelectElement(selectedElement: Geofence, selected: boolean) {
        this.geoFencesStore.addSelectElement(selectedElement, selected, 'geofence_id');
    }

    handleChangeFilter(filter: string): void {
        this.geoFencesStore.setFilter(filter);
    }

    loadData(): void {
        if (this.companySelected !== null) {
            this.errorState = false;
            this.geoFencesStore.updateLoading(true);
            TrackingService.getGeofenceByCompany(this.companySelected as string, this.$_isMock)
                .then((response: any) => {
                    this.geoFencesStore.updateLoading(false);
                    this.geoFencesStore.setElements(response.geofences);
                })
                .catch(error => {
                    this.geoFencesStore.updateLoading(false);
                    this.errorState = true;
                    this.$_catchLoadingDialog({
                        response: error,
                        alternative_msg: getGeofenceError
                    })
                });
        }
    }

    handleDeleteElements(elements: Geofence[]): void {
        const ids = elements.map(geofence => geofence.geofence_id);
        this.loadingDelete = true;
        TrackingService.deleteGeofences(ids)
            .then(response => {
                if ((response && response['status'] === 200) || response['status'] === 204) {
                    if (response['data'] && response['data'].message) {
                        this.$_showDeleteGeofences(response['data'].message);
                    } else {
                        this.$_showDeleteGeofences('Eliminado correctamente');
                    }

                    this.geoFencesStore.setSelected([]);
                    this.geoFencesStore.removeElements(elements, 'geofence_id');
                } else {
                    this.$_errorDeleteGeofences('Problema eliminando');
                }
                this.loadingDelete = false;
                this.managementGeofences.setOpenConfirmation(false);
            })
            .catch(error => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudieron eliminar las geocercas'
                })
                this.loadingDelete = false;
                this.managementGeofences.setOpenConfirmation(false);
            });
    }

    get managementGeofences(): any {
        return this.$refs.managementGeofences;
    }

    @Emit()
    center(points: Point[]) {}

    handleCenter(geoFence: Geofence): void {
        let points: Point[] = [];
        for (let i = 0; i < geoFence.polygons.length; i++) {
            for (let j = 0; j < geoFence.polygons[i].points.length; j++) {
                points.push(geoFence.polygons[i].points[j]);
            }
        }
        const bounds: google.maps.LatLngBounds = getBoundsFromPosition(points, false, 0);
        const center: google.maps.LatLng = bounds.getCenter();
        this.center(points);
    }

    @Emit()
    waitForAddGeoFence(): void {}

    @Emit()
    waitForEditGeoFence(geoFence: Geofence): void {}
}
